import React from 'react';
import ProvidesRow from './ProvidesRow';
import { FormattedMessage } from 'react-intl';
import randomstring from 'uuid/v4';

import AddIcon from '@material-ui/icons/AddCircle';

import Dialog from './DialogReferences';

export default class ContactsTable extends React.Component {
    state = {
        data: {},
    };

    static getDerivedStateFromProps(props, state) {
        if (props.data !== state.data) {
            state.data = props.data ? props.data : [];
            return state;
        }
        return null;
    }

    handleRowDel = (row) => {
        const arr = [...this.state.data];
        var index = this.state.data.indexOf(row);
        arr.splice(index, 1);
        const event = {
            target: {
                name: 'provee',
                value: arr,
            },
        };
        this.setState({ data: arr });
        this.props.onChange(event);
    };

    handleAddEvent = () => {
        var row = {
            id: randomstring(),
            locales: [],
            idReferencia: undefined,
            nombreReferencia: '',
            idPresentacion: undefined,
            nombrePresentacion: '',
        };
        this.setState({ open: row });
    };

    handleUpdateTable = (row) => {
        this.setState({ open: row });
    };

    handleClose = (row) => {
        if (row) {
            const { data } = this.state;
            const reference = this.props.references.find((element) => {
                return element.id.toString() === row.idReferencia.toString();
            });
            row.nombreReferencia = reference ? reference.nombre : '';
            const presentacion = reference
                ? reference.presentaciones.find(
                    (element) => element.id.toString() === row.idPresentacion.toString(),
                )
                : undefined;
            row.nombrePresentacion = presentacion ? presentacion.nombre : '';
            row.locales = row.locales.map((l) => {
                return { id: l.id, nombre: l.name };
            });

            const index = data.map((i) => i.id).indexOf(row.id);
            if (index >= 0) {
                data[index] = row;
            } else {
                data.push(row);
            }

            this.setState({ data: data, open: undefined });
            const event = {
                target: {
                    name: 'provee',
                    value: data,
                },
            };
            this.props.onChange(event);
        } else {
            this.setState({ open: undefined });
        }
    };

    render() {
        const { data, open } = this.state;
        const updaterow = this.handleUpdateTable;
        const delrow = this.handleRowDel;

        return (
            <div className={'container-table100 flex_full_column'}>
                <div className="flex_full_row align_center padding_bottom_24 width100">
                    <div className={'barlow_medium_italic c_slate_grey flex_full_row'}>
                        <FormattedMessage id="manage_reference_menu" />
                    </div>
                    <AddIcon
                        className={'c_bluish hand'}
                        fontSize="large"
                        onClick={this.handleAddEvent}
                    />
                </div>
                <section className="flex_full_column table100">
                    <header className="flex_auto_row">
                        <div className="col"><FormattedMessage id="product_table_product" /></div>
                        <div className="col"><FormattedMessage id="form_field_name_presentation" /></div>
                        <div className="" />
                    </header>
                    <div className="flex_full_column tbody">
                        {data &&
                            data.map((i) => (
                                <ProvidesRow
                                    data={i}
                                    key={randomstring()}
                                    onDelEvent={delrow}
                                    onEditEvent={updaterow}
                                />
                            ))}
                    </div>
                </section>
                {open && <Dialog {...this.props} value={open} onClose={this.handleClose} />}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/complex/manage/provider/ProvidesTable.js